App.controller('apptCommonCtrl', ($scope, $api, $rootScope, responseHelper, Appointment, Perm, ngDialog, datesInTimezone) => {

  $scope.min_appt_length = 15
  $scope.appt_types = $scope.ngDialogData.appt_types
  $scope.is_range_selected = $scope.ngDialogData.is_range_selected
  $scope.other_appt_type = {appt_category: {name: "Other", category: "Other", minutes: 15}, id: 0, category: "Other"}

  dateAddMinutes = (date, minutes) => {
    return moment(date).add(minutes,'m').toISOString()
  }

  $scope.loaddocs = () => Perm.friends({no_self: true}).then(({ result }) => {
    $scope.providers = _.sortBy(result, (prov) => { return prov.display_name || prov.name })
  })

  $scope.setMyMinutes = () => {
    if (!$scope.appt) { return }

    var startmoment = $scope.appt.start_time
    var endmoment = $scope.appt.end_time
    $scope.myminutes = (moment(endmoment) - moment(startmoment)) / 60000
    if ($scope.myminutes > 24 * 60) {
      // show full date if appt is longer than 24 hours
      $scope.appt.long_running = true
    } else {
      $scope.appt.long_running = false
    }
  }

  $scope.timeUpdate = (newDate, is_start, user_tz = true) => {
    if (user_tz) {
      newDateStr = datesInTimezone.convertFromUserToLocTimezone(newDate)
    } else {
      newDateStr = moment(newDate).toISOString()
    }
    if(is_start){
      $scope.appt.start_time = newDateStr
      $scope.appt.start_time_with_tz = datesInTimezone.convertFromUtcToLocalTimezone(newDateStr, true)
      if($scope.appt.appointment_type_id){
        $scope.chooseApptType($scope.appt.appointment_type_id) // set end time based on a current appt type
      }
    } else {
      $scope.appt.end_time = newDateStr
      $scope.appt.end_time_with_tz = datesInTimezone.convertFromUtcToLocalTimezone(newDateStr, true)
    }
    $scope.setMyMinutes()
  }

  watchProviderChange = () => {
    $scope.$watch('appt.provider_id', (nv,ov) => {
      if(typeof nv == 'number'){
        $scope.setMinApptLength(nv)
      }
    })
  }

  $scope.setMinApptLength = (id) => {
    var provider = _.find($scope.providers, (provider) => provider.id == id)
    if(typeof provider != 'undefined'){
      $scope.min_appt_length = provider.min_appt_length || 15
    }
    $rootScope.$broadcast('refreshDatetimepicker')
  }

  $scope.chooseApptType = (appt_type_id) => {
    appt_type = _.find($scope.appt_types, i => {return i.id == appt_type_id})
    if(!angular.isUndefined(appt_type) && appt_type !== null && appt_type.id !== 0) {
      $scope.myminutes = appt_type.appt_category.minutes
    } else {
      let timeDiff = (new Date(moment($scope.appt.end_time))) - (new Date(moment($scope.appt.start_time)))
      if(timeDiff > 0){
        $scope.myminutes = timeDiff/(60*1000)
      } else {
        $scope.myminutes = 15
      }
    }
    $scope.timeUpdate(dateAddMinutes($scope.appt.start_time, $scope.myminutes), false, false)
  }

  $scope.chooseProvider = (id) => {
    $scope.appt.provider_id = id

    if ($scope.loadAppointmentTypes) {
      $scope.loadAppointmentTypes()
    }
  }

  $scope.get_prov_name = (id) => {
    return _.find($scope.providers, {'id': id}).name
  }

  $scope.select_appt_type = (id) => {
    $scope.appt.appointment_type_id = id
  }

  $scope.isEndTimeEditable = (appt) => {
    if ($scope.appt.unavailable) {
      return true
    }
  }

  $scope.saveWithLongRunningCheck = (appt, callback) => {
    if (moment(appt.end_time).diff(appt.start_time, 'minutes') > 24 * 60) {
      if (appt.unavailable) {
        entity_name = 'unavailable slot'
      } else {
        entity_name = 'appointment'
      }
      dialog = ngDialog.open({
        template: '/app/views/modal/confirm.html',
        data: {
          text: `Are you sure you want to save ${entity_name} longer than 24 hours?`
        },
        controller: 'confirmCtrl',
        className: 'ne__modal'
      })
      dialog.closePromise.then(d => {
        if(d.value === true){
          callback()
        }
      })
    } else {
      callback()
    }
  }
})
